<template>
  <div class="archive bg-color-dark">
    <vue-headful :title="doctitle" />
    <b-container class="pb-5">
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h1 class="mt-5 text-color-light big-headline">Archive</h1>
          <p class="text-color-light">
            You can have a look at Øredev’s Conference previous years; from the
            fifth Øredev in 2009 up to the one last year. You can as well watch
            the videos from previous years.
          </p>
          <a
            target="_blank"
            class="archive-link"
            href="https://archive.oredev.org/2022/index.html#/"
          >
            <b-button class="btn-1"> 2022 </b-button>
          </a>

          <a target="_blank" href="https://archive.oredev.org/2019/home.html">
            <b-button class="btn-1"> 2019 </b-button>
          </a>

          <a target="_blank" href="https://archive.oredev.org/2018/2018.html">
            <b-button class="btn-1"> 2018 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/2017/2017/start.html"
          >
            <b-button class="btn-1"> 2017 </b-button>
          </a>

          <a target="_blank" href="https://archive.oredev.org/2016/2016.html">
            <b-button class="btn-1"> 2016 </b-button>
          </a>

          <a target="_blank" href="https://archive.oredev.org/2015/2015.html">
            <b-button class="btn-1"> 2015 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2014/index.html"
          >
            <b-button class="btn-1"> 2014 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2013/2013.html"
          >
            <b-button class="btn-1"> 2013 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2012/2012/start.html"
          >
            <b-button class="btn-1"> 2012 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2011/2011/start.html"
          >
            <b-button class="btn-1"> 2011 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2010/2010.html"
          >
            <b-button class="btn-1"> 2010 </b-button>
          </a>

          <a
            target="_blank"
            href="https://archive.oredev.org/oredev2009/2009/start.html"
          >
            <b-button class="btn-1"> 2009 </b-button>
          </a>
        </b-col>
        <b-col xl="1"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "archive",
  data() {
    return {
      doctitle: "Archive - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
ul {
  list-style: none;
  padding-left: 0;
}

.btn-1 {
  background: #292929 !important;
}

.btn-1:hover {
  background: $orange !important;
  color: white !important;
}

.archive-link {
  text-decoration: none !important;
}
button {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Archive.vue